import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface VisibilityEyeIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * VisibilityEye icon using SF Pro font symbol (􀋭)
 *
 * This icon represents visibility/eye status in toggles and switches.
 * Used in the ANYW3AR app for public profile visibility controls.
 *
 * @example
 * ```tsx
 * <VisibilityEyeIcon />
 * <VisibilityEyeIcon size={8} weight="bold" />
 * ```
 */
export const VisibilityEyeIcon = React.forwardRef<HTMLSpanElement, VisibilityEyeIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀋭" {...props} />
  }
)

VisibilityEyeIcon.displayName = "VisibilityEyeIcon"
